export const Jonctions = {
  NA: 'NA',
  ARRETIER: 'arretier',
  NOUE: 'noue',
  SOLIN: 'solin',
};
